// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './Alternative.css'
import { Button } from '../../../../../../components/Button/Button'

import type { Alternative as AlternativeType } from '../../../../../../types'
import { bem } from '../../../../../../helpers/bem'
import { themeToClassName } from '../../../../../../helpers/themeToClassName'
import { breakpointToClassName } from '../../../../../../helpers/breakpointToClassName'

type Props = {
  onClick: (alternative: AlternativeType) => void,
  alternative: AlternativeType,
  isLastItem: boolean,
  totalAlternativesCount: number
}

export class Alternative extends Component<Props> {
  handleAlternativeClicked = () => {
    this.props.onClick(this.props.alternative)
  }

  render () {
    const { alternative, isLastItem, totalAlternativesCount } = this.props
    const { theme, currentBreakpoint } = this.context
    return (
      <div
        className={bem(
          styles.alternative,
          isLastItem ? 'last-item' : '',
          totalAlternativesCount % 2 !== 0 ? 'part-of-odd-list' : '',
          themeToClassName(theme),
          breakpointToClassName(currentBreakpoint)
        )}
      >
        <Button
          className={styles.button}
          onClick={this.handleAlternativeClicked}
        >
          {alternative.text}
        </Button>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/components/LivePoll/AlternativeList/components/Alternative.js